import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { ApiError, TokenUsageParams, TokenUsageResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<TokenUsageResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchTokenUsage = async (
    params: TokenUsageParams
): Promise<TokenUsageResponse> => {
    const url = apiEndpoints.tokenUsage.getReport(params);
    const response = await api.get(url);
    const payload = response?.data?.data;
    return Array.isArray(payload) ? payload : (payload?.data ?? []);
};

const useTokenUsage = (params: TokenUsageParams, options?: QueryOptions) => {
    return useQuery<TokenUsageResponse, ApiError>({
        queryKey: ['tokenUsage', 'list', params],
        queryFn: () => fetchTokenUsage(params),
        ...options,
        enabled: Boolean(params.start && params.end),
    });
};

export default useTokenUsage;
